import { EmailRedirect } from './pages'

export const routes = {
  emailRirect: {
    path: '/e/*',
    exact: true,
    component: EmailRedirect,
  },
}
